import React from 'react';

// BL-177 Step 2d (section 1): the one on/off switch, at HALF the old size. Track 34x18, knob 14, recessed
// track + raised knob, teal when on. Used ONLY for whole on/off settings (a company-wide notification
// switch, a device switch, an open/closed day, quiet hours). Channels use <Checkbox>.
// State is never colour-only: the ON / OFF word sits beside the track (hide it with showState={false}
// when the row's own words already say it, e.g. "On for The Ride"). A real <button role="switch">, so
// Space and Enter work and focus is visible. `busy` marks a save in flight but does NOT disable the
// switch, so a person can keep flipping and the caller's queue stays in order.
export default function Switch({
    checked,
    onChange,
    label,
    'aria-label': ariaLabel,
    id,
    describedBy,
    disabled = false,
    busy = false,
    onText = 'ON',
    offText = 'OFF',
    showState = true,
    className = '',
}) {
    const on = checked === true;
    return (
        <span className={`inline-flex items-center gap-2 ${className}`}>
            <button
                type="button"
                id={id}
                role="switch"
                aria-label={ariaLabel || label}
                aria-checked={on}
                aria-describedby={describedBy || undefined}
                aria-busy={busy || undefined}
                disabled={disabled}
                data-ia-switch={on ? 'on' : 'off'}
                onClick={() => { if (!disabled && onChange) onChange(!on); }}
                className={`ia-switch ${busy ? 'animate-pulse' : ''}`}
            >
                <span aria-hidden="true" className="ia-switch__knob" />
            </button>
            {showState && (
                <span aria-hidden="true" data-switch-state={on ? 'on' : 'off'} className="w-7 text-xs font-bold tracking-wide text-[var(--ia-ink,var(--ink))]">
                    {on ? onText : offText}
                </span>
            )}
        </span>
    );
}
